'use client'

import { PropsWithChildren } from 'react'
import { motion } from 'motion/react'
import { usePrefersReducedMotion } from './usePrefersReducedMotion'
import { MORPH_TRANSITION } from './constants'

type MorphDialogIconProps = {
  morphId: string
  className?: string
}

export function MorphDialogIcon({
  morphId,
  className,
  children,
}: PropsWithChildren<MorphDialogIconProps>) {
  const prefersReducedMotion = usePrefersReducedMotion()

  if (prefersReducedMotion) {
    return <div className={className}>{children}</div>
  }

  return (
    <motion.div
      layoutId={`morph-icon-${morphId}`}
      className={className}
      transition={MORPH_TRANSITION.layout}
    >
      {children}
    </motion.div>
  )
}
